import { createSlice } from "@reduxjs/toolkit";

export const AdminSlice = createSlice({
  name: "admin",
  initialState: {
    sessions: [],
    isLoading: false,
    error: null,
    success: false,
  },
  reducers: {
    setSessions: (state, { payload }) => {
      state.sessions = payload;
      state.error = null;
    },
    setLoading: (state, { payload }) => {
      state.isLoading = payload;
    },
    setError: (state, { payload }) => {
      state.error = payload;
    },
    setSuccess: (state, { payload }) => {
      state.success = payload;
    },
  },
});

export const { setSessions, setLoading, setError, setSuccess } =
  AdminSlice.actions;
export default AdminSlice.reducer;
